import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/yelloop.svg'


const _withScopeId = n => (_pushScopeId("data-v-1169746c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container pt-5"
}
const _hoisted_2 = { class: "d-flex justify-content-center mb-1 heading pb-3 pb-sm-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line col-lg-3" })
], -1))
const _hoisted_6 = { class: "main-title text-center pb-5 fw-bold" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "p-sm-4 p-2 row item" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { class: "col-sm-2 item-header d-flex d-sm-block mt-3 mt-sm-0" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['item-notice mt-3 text-white d-flex justify-content-center align-items-center fw-bold small-title m-wait'])
}
const _hoisted_13 = { class: "col-sm-10 description" }
const _hoisted_14 = { class: "me-2 fs-5" }
const _hoisted_15 = { class: "item-des mt-2 mt-sm-0 text-break break-spaces" }
const _hoisted_16 = { class: "p-sm-4 p-2 row item" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "col-sm-2 item-header d-flex d-sm-block mt-3 mt-sm-0" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "col-sm-10 description" }
const _hoisted_21 = { class: "me-2 fs-5" }
const _hoisted_22 = { class: "item-des mt-2 mt-sm-0 text-break break-spaces" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode()
const _hoisted_24 = /*#__PURE__*/_createTextVNode()
const _hoisted_25 = {
  key: 2,
  class: "container empty d-flex aign-items-center justify-content-center"
}
const _hoisted_26 = { class: "d-flex justify-content-center mb-1 heading" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line col-lg-3" })
], -1))
const _hoisted_30 = { class: "main-title text-center pb-5 fw-bold" }
const _hoisted_31 = {
  class: "modal fade",
  id: "modalView",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_32 = { class: "modal-dialog" }
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_35 = { class: "modal-body content mx-lg-auto mx-1" }
const _hoisted_36 = { class: "text-center py-4 fw-bold" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { onMounted, ref, onUnmounted, watch, computed } from 'vue'
import { translate } from '@/languages/i18n'
import LobbySkeleton from '@/components/skeletons/LobbySkeleton.vue'
import { useStore } from 'vuex'
import { COMMUNITY_STORE } from '@/store/constants'
import { addCommunityHeaderParams } from '@/use/usePath'
import { Modal } from 'bootstrap'
import { useRoute, useRouter } from 'vue-router'
import communityServices from '@/services/communities.service'

type Community = {
  id: number
  name: string
  description: string
  corporation_name: string
  image_url: string | any
  display_corporation_name: string
  community_published: boolean
  community_available: boolean
  community_information_available: boolean
  alumni_examinated: any
  contract_in_90_days: boolean
  admin: boolean
}[]

// 2022/10/05 TuanTT Add community pagiantion UAT#4485: SD10,CB11(Ph2-R20221014)
type CommunityData = {
  data: any
  total_pages: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
  isAdmin: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const route = useRoute()
const router = useRouter()
const store = useStore()
const observer = ref()
const currentPage = ref<number>(1)
const lastCommunity = ref<HTMLElement>()
const paramGetCommunity = ref()
const community = computed<CommunityData>(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY])
const loading = computed<boolean>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_LOADING])
const communities = computed<Community>(() => community?.value?.data || [])
const checkBlockIPLoading = ref<string>('')

const communitiesAll = store.getters[COMMUNITY_STORE.GETTERS.COMMUNITIES]
const navigateToCommunityPages = (communityId: string, navigateDestination: 'admin' | 'community') => {
  if (navigateDestination === 'admin') {
    router.push(`/community/communities/${communityId}/dashboard`)
  } else {
    router.push(`/community/communities/${communityId}`)
  }
}

const handleCommunityItemNavigation = (communityId: string, navigateDestination: 'admin' | 'community') => {
  checkBlockIPLoading.value = `${navigateDestination}-${communityId}`
  communityServices
    .getPopularTags(communityId, true)
    .then((res) => {
      if (res && res.status === 200) {
        navigateToCommunityPages(communityId, navigateDestination)
      }
    })
    .catch((_) => {
      navigateToCommunityPages(communityId, navigateDestination)
    })
    .finally(() => {
      checkBlockIPLoading.value = ''
    })
}

const showDisabled = (item: any) => {
  if (!props.isAdmin) {
    if (item?.contract_in_90_days || !item?.community_published || !item?.community_available || !item?.community_information_available || !item?.alumni_examinated) {
      return 'item-todo-active  cursor-pointer'
    }
    return ''
  } else {
    if (!item?.community_available || !item?.community_information_available || item?.contract_in_90_days) {
      return 'item-todo-active  cursor-pointer'
    } else if (!item.admin && !item?.community_published) {
      return 'item-todo-active  cursor-pointer'
    }
    return ''
  }
}

onMounted(async () => {
  // 2022/10/05 TuanTT Add community pagiantion UAT#4485: SD10,CB11(Ph2-R20221014)
  await getCommunity(false)
  modalView.value = new Modal(document.getElementById('modalView'))
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
  while (modalBackdrop.length > 0) {
    modalBackdrop[0].parentNode.removeChild(modalBackdrop[0])
  }

  // 2022/10/05 TuanTT Add community pagiantion UAT#4485: SD10,CB11(Ph2-R20221014)
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      if (currentPage.value === community.value.total_pages) return
      if (communities.value.length < 100) return
      currentPage.value++
      getCommunity(true)
    }
  })
  if (lastCommunity.value) {
    observer?.value?.observe(lastCommunity.value)
  }

  checkAndHandleSnsLoginResult()
})

/**
 * When sns-authentication result is forward to login page through URL
 * after its has been handle in router-interceptor, it needed to be removed
 * from URL to avoid unwanted risks
 */
const checkAndHandleSnsLoginResult = () => {
  const { auth_token } = route.query
  if (auth_token) {
    router.replace({ ...router.currentRoute, query: {} })
  }
}

const getCommunity = async (change: boolean) => {
  paramGetCommunity.value = {
    change,
    params: { page: currentPage.value, page_of_number: 100 },
  }
  await store.dispatch(COMMUNITY_STORE.ACTIONS.GET_COMMUNITY, paramGetCommunity.value)
}

const modalView = ref()

watch(
  () => lastCommunity.value,
  () => {
    if (lastCommunity.value) {
      observer?.value?.observe(lastCommunity.value)
    }
  }
)

const openModalView = (community) => {
  if (community?.community_available && community?.community_published && community?.community_information_available && community?.alumni_examinated === null) {
    modalView.value?.show()
  }
}

onUnmounted(() => {
  observer.value?.disconnect()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(communities).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)('SD10heading')), 1)
          ]),
          _hoisted_5,
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(translate)('SD10title')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(communities), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "d-flex justify-content-center"
            }, [
              (!__props.isAdmin)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`bg-white shadow position-relative col-xl-8 mb-4 h-100 col-12 rounded-4 ${showDisabled(item)}`),
                    onClick: ($event: any) => (openModalView(item))
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("img", {
                            src: item?.image_url ? _unref(addCommunityHeaderParams)(item?.image_url, item?.id) : require('@/assets/images/community_no_image.svg'),
                            alt: "img"
                          }, null, 8, _hoisted_11),
                          (item?.community_available && item?.community_published && item?.community_information_available && item?.alumni_examinated === null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(translate)('SD10view')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'd-flex fw-bold align-items-baseline mb-4',
                  item.community_available && item.community_information_available && item.community_published && item.alumni_examinated && !_ctx.contract_in_90_days
                    ? 'active'
                    : 'inactive',
                ])
                          }, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.name) + " " + _toDisplayString(item.display_corporation_name), 1)
                          ], 2),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(item.description), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass([
              item.community_available && item.community_information_available && item.community_published && item.alumni_examinated
                ? 'd-flex justify-content-center justify-content-sm-end'
                : 'd-none',
              'item-action py-2 py-sm-0',
            ])
                      }, [
                        (item.admin === null && item.community_published && !item?.contract_in_90_days)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/alumni/communities/${item.id}`,
                              class: "fs-7 text-black text-decoration-none d-flex align-items-center justify-content-center shadow rounded-pill px-3 py-2 border button-router-link"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)('SD10button')), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ], 10, _hoisted_7))
                : _createCommentVNode("", true),
              (__props.isAdmin)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`bg-white shadow  position-relative col-xl-8 mb-4 h-100 col-12 rounded-4 ${showDisabled(item)}`)
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("img", {
                            src: item?.image_url ? _unref(addCommunityHeaderParams)(item?.image_url, item?.id) : require('@/assets/images/community_no_image.svg'),
                            alt: "img"
                          }, null, 8, _hoisted_19)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'd-flex fw-bold align-items-baseline mb-4',
                  item.community_available && item.community_information_available && !item.contract_in_90_days ? 'active' : 'inactive',
                ])
                          }, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(item.name) + " " + _toDisplayString(item.display_corporation_name), 1)
                          ], 2),
                          _createElementVNode("p", _hoisted_22, _toDisplayString(item.description), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass([
              item.community_available && item.community_information_available ? 'd-flex justify-content-center justify-content-sm-end' : 'd-none',
              'item-action py-2 py-sm-0',
            ])
                      }, [
                        (item.admin && !item?.contract_in_90_days)
                          ? (_openBlock(), _createBlock(Button, {
                              key: 0,
                              title: _unref(translate)('toManagementScreen'),
                              loading: checkBlockIPLoading.value === `admin-${item.id}`,
                              disabled: checkBlockIPLoading.value !== '',
                              size: "small",
                              onClick: ($event: any) => (handleCommunityItemNavigation(item.id, 'admin')),
                              class: "lobby-button bg-white text-black px-4 py-2 rounded-pill d-flex justify-content-center align-items-center text-decoration-none border shadow fs-7 me-2 button-router-link"
                            }, null, 8, ["title", "loading", "disabled", "onClick"]))
                          : _createCommentVNode("", true),
                        (item.admin !== null && (item.admin || item.community_published) && !item?.contract_in_90_days && !item?.is_daiko)
                          ? (_openBlock(), _createBlock(Button, {
                              key: 1,
                              loading: checkBlockIPLoading.value === `community-${item.id}`,
                              disabled: checkBlockIPLoading.value !== '',
                              size: "small",
                              onClick: ($event: any) => (handleCommunityItemNavigation(item.id, 'community')),
                              class: "lobby-button bg-white fs-7 text-black text-decoration-none d-flex align-items-center justify-content-center shadow rounded-pill px-3 py-2 border button-router-link",
                              title: _unref(translate)('SD10button')
                            }, null, 8, ["loading", "disabled", "onClick", "title"]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_unref(communities).length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: (_value, _refs) => {
                  _refs['lastCommunity'] = _value
                  lastCommunity.value = _value
                }
              }, null, 512))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["container d-flex justify-content-center align-items-center flex-column", { 'pt-5': _unref(loading) && !_unref(communities).length }])
        }, [
          _createVNode(LobbySkeleton),
          _hoisted_23,
          _createVNode(LobbySkeleton),
          _hoisted_24,
          _createVNode(LobbySkeleton)
        ], 2))
      : _createCommentVNode("", true),
    (!_unref(loading) && _unref(communities)?.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(translate)('SD10heading')), 1)
          ]),
          _hoisted_29,
          _createElementVNode("h1", _hoisted_30, _toDisplayString(_unref(translate)('SD10titleWhenEmptyCommunity')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(translate)('SD10titleModal')), 1),
            _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(translate)('SD10modalContent1')), 1),
            _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(translate)('SD10modalContent2')), 1),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(Button, {
                title: _unref(translate)('close'),
                type: 'secondary',
                "data-bs-dismiss": "modal"
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})